// extracted by mini-css-extract-plugin
export default {"quote-table":"quote-table___llNiq","required-text":"required-text___DkWmJ","total-price":"total-price____r_8K","render-label":"render-label___Ob4WP"};